import { useEffect } from 'react';
import type { Branding } from '../types';

export function useBranding(branding: Branding | undefined) {
  useEffect(() => {
    if (!branding) return;
    const root = document.documentElement;
    if (branding.primaryColor) root.style.setProperty('--primary-color', branding.primaryColor);
    if (branding.accentColor) root.style.setProperty('--accent-color', branding.accentColor);

    return () => {
      root.style.removeProperty('--primary-color');
      root.style.removeProperty('--accent-color');
    };
  }, [branding?.primaryColor, branding?.accentColor]);
}
